import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/product-categories/:productCategoryId/deactivate`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const deactive = {
  post: apiPathFunc(pathBase),
};
